export default __webpack_public_path__ + "static/media/25255f00a40cede067b5b1ad951154151581618834373.3c8ff8fd.webp";